import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 pt-20">
        <div className="text-center">
          <h1 className="font-heading text-8xl md:text-9xl font-bold text-foreground-200 mb-4">
            404
          </h1>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            页面未找到
          </h2>
          <p className="text-foreground-500 mb-8 max-w-md mx-auto">
            抱歉，您访问的页面不存在或已被移除。可能这个瓜已经被吃掉了，试试首页寻找新的爆料吧！
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 text-sm font-medium rounded hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-line" />
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}